export function pick (obj, ...props) {
  return props.reduce(function (result, prop) {
    result[prop] = obj[prop]
    return result
  }, {})
}

export function omit (obj, ...props) {
  const result = { ...obj }
  props.forEach(function (prop) {
    delete result[prop]
  })
  return result
}
